// extracted by mini-css-extract-plugin
var _1 = "RoleListItemContent-modulehover__T7Jdz";
var _2 = "RoleListItemContent-moduletext__nvoqO";
export { _1 as "hover", _2 as "text" }
